<template>
    <div>
        <h1 style="text-align: center;">Infographic3/Graphs Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Thumbnail</h2>
                <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="thumbsel" v-on:change="changeImage(thumbnail, 'thumbsel')" accept="image/jpeg,image/png,image/tif" style="width: 100%; color: black;"></div>
            </div>
            <div v-for="(chart, i) in data" :key="'cntAllcharts' + i" class="all-charts">
            <hr style="width: 100%;">
                <select v-model="chart.type">
                    <option value="line">Line Chart</option>
                    <option value="bar">Bar Chart</option>
                </select>
                <div class="chart-holder" v-if="chart.type == 'line'">
                    <LineChart :chartdata="chart.chartdata" :options="chart.options" :ref="'linechart' + i"></LineChart>
                </div>
                <div class="chart-holder" v-if="chart.type == 'bar'">
                    <BarChart :chartdata="chart.chartdata" :options="chart.options" :ref="'barchart' + i"></BarChart>
                </div>
                <div style="display: flex; flex-direction: row; width: 100%;" @keyup="onDataChange(i)">
                    <div style="display:flex; flex: 15%; flex-direction: column;">
                        <div><h3><input type="text" value="Labels" disabled style="width: 100%;"></h3></div>
                        <div v-for="(label, li) in chart.chartdata.labels" :key="'label' + li">
                            <input type="text" v-model="chart.chartdata.labels[li]">
                            <input type="button" value="X" style="background: red; color: white" @click="deleteLine(i, li)">
                        </div>
                        <div><input type="button" value="Add New Line" @click="addNewLine(i)"></div>
                    </div>
                    <div style="display:flex; flex: 75%; flex-direction: row;">
                        <div style="display: flex; flex-direction: column;" v-for="(cdat, ci) in chart.chartdata.datasets" :key='"cdat" + i + "-" + ci'>
                            <div><h3>
                                <input type="text" v-model="chart.chartdata.datasets[ci].label" style="width: 80%;">
                                <input type="color" v-model="chart.chartdata.datasets[ci].backgroundColor" style="width: 20%; height: 1.3em;" @change="onDataChange(i)">
                            </h3></div>
                            <div v-for="(dat, di) in chart.chartdata.datasets[ci].data" :key="'dat' + di">
                                <span v-if="di != chart.chartdata.datasets[ci].data.length-1"><input type="text" v-model="chart.chartdata.datasets[ci].data[di]" style="width: 100%;"></span>
                                <span v-if="di == chart.chartdata.datasets[ci].data.length-1"><input type="button" value="Delete Dataset" @click="deleteData(i, ci)" style="width: 100%; background: red; color: white;"></span>
                            </div>
                        </div>
                        <button @click="addNewDataset(i)" style="flex: 10%;">
                            Add New
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <button @click="addNew()" class="submit-btn">Add New Chart</button>
                <button @click="submitThis()" class="submit-btn">Submit</button>
                <hr>
            </div>
        </div>
    </div>
</template>

<script>
import {Functions} from './functions.js';
  import LineChart from '@/components/Interactive/Infographic3/Infographic3LineChart'
  import BarChart from "@/components/Interactive/Infographic3/Infographic3BarChart"
export default {
    name: "ChartsAddEditComponent",
    props: ["ID"],
    components: {
      LineChart,
      BarChart
    },
    data: () => ({
        isLoading: true,
        title: "",
        id: undefined,
        data: [],
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        functions: undefined,
        buffer: undefined
    }),
    mounted: function(){
        this.functions = new Functions();
        if(this.ID){
            console.log("EDITING:", this.ID);
            
            this.functions.getComponent(this.ID, (data) => {
                console.log(data);
                this.id = data.contentId;
                this.title = data.title;
                this.data = data.data.chartDat;
                this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
                this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "getObject", (thumbBuff) => {
                    this.thumbnail.data = (thumbBuff.signedUrl);
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "putObject", (thumbBuff1) => {
                        this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                        this.isLoading = false;
                    });
                });
            });
        }else{
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.addNew();
            });
        }
    },
    methods: {
        submitThis: function(){
            this.isLoading = true;
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error");
            if(this.ID){
                //thumb test no needed
            }else{
                if(this.thumbnail.file == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
                else this.$refs.cntThumb.classList.remove("has-error");
            }
            if(this.data.length == 0){alert("No graph entries available, select minimum 1"); hasError = true;}

                     const replacerFunc = () => {
                        const visited = new WeakSet();
                        return (key, value) => {
                        if (typeof value === "object" && value !== null) {
                            if (visited.has(value)) {
                            return;
                            }
                            visited.add(value);
                        }
                        return value;
                        };
                    };
                    let componentData = {
                        ContentType: "INTERACTIVE",
                        Title: this.title,
                        Thumbnail: this.thumbnail.publicUrl,
                        Component: "infographic3",
                        Data: {
                                title: this.title,
                                chartDat: JSON.parse(JSON.stringify(this.data, replacerFunc()))
                        }
                    };
                    componentData.Data.chartDat.forEach((chart, i) => {
                        chart.chartdata.datasets.forEach((dset, di) => {
                            delete componentData.Data.chartDat[i].chartdata.datasets[di]._meta;
                        });
                    });
                    console.log(componentData);

            if(!hasError){
                console.log("UPLOADING");
                if(this.ID){
                    //edit component
                    this.functions.updateComponent(this.ID, componentData,(dat) => {
                        console.log(dat);
                        if(this.thumbnail.file != undefined){
                            this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                                console.log(dat);
                                this.$router.push("/editors/component/infographic3");
                            });
                        }else{
                            this.$router.push("/editors/component/infographic3");
                        }
                    });
                }else{
                    // return null;

                    this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                        this.functions.addComponent(componentData,(dat) => {
                            console.log(dat);
                            this.$router.push("/editors/component/infographic3");
                        });
                    });
                }
            }else{
                alert("Please fix any errors in the above form.");
                this.isLoading = false;
            }
        },
        changeImage: function(img, selref){
            var reader = new FileReader();
            reader.onload = (e) => {
                img.data = e.target.result;
            }
            if(this.$refs[selref].length){
                reader.readAsDataURL(this.$refs[selref][0].files[0]);
                img.file = this.$refs[selref][0].files[0];
            }else{
                reader.readAsDataURL(this.$refs[selref].files[0]);
                img.file = this.$refs[selref].files[0];
            }
        },
        onDataChange: function(i){
            this.$refs[this.data[i].type + "chart" + i][0].$forceUpdate(true);
        },
        addNew: function(){
            this.isLoading = true;
            this.data.push({
                type: "line",
                chartdata: {
                    labels: ["label1", "label2", "label3"],
                    datasets: [
                        {
                            label: "type1",
                            backgroundColor: "#47F92A",
                            data: [5,6,7,0]
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false
                }
            });
            this.isLoading = false;
        },
        addNewDataset: function(i) {
            let buff = [];
            this.data[i].chartdata.labels.forEach(x => buff.push(0));
            buff.push(0);
            this.data[i].chartdata.datasets.push({
                label: "Data",
                backgroundColor: "#ffffff",
                data: buff
            });
            this.$refs[this.data[i].type + "chart" + i][0].$forceUpdate(true);
        },
        addNewLine: function(i){
            this.data[i].chartdata.labels.push("LABEL");
            this.data[i].chartdata.datasets.forEach((dset, di) => {
                this.data[i].chartdata.datasets[di].data.push(0);
            });
            this.$refs[this.data[i].type + "chart" + i][0].$forceUpdate(true);
        },
        deleteLine: function(i, li){
            let c = confirm("Are you sure you want to delete '" + this.data[i].chartdata.labels[li] + "' FROM chart #" + (i+1));
            if(c){
                this.data[i].chartdata.labels.splice(li, 1);
                this.data[i].chartdata.datasets.forEach((dset, di) => {
                    this.data[i].chartdata.datasets[di].data.splice(li, 1);
                });
                this.$refs[this.data[i].type + "chart" + i][0].$forceUpdate(true);
            }
        },
        deleteData: function(i, ci){
            let c = confirm("Are you sure you want to delete '" + this.data[i].chartdata.datasets[ci].label + "'");
            if(c){
                this.data[i].chartdata.datasets.splice(ci, 1);
                this.$refs[this.data[i].type + "chart" + i][0].$forceUpdate(true);
            }
        },
    }
};
</script>

<style scoped>
textarea{
    width: 100%;
}
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    hr{
        border: solid 2px white;
    }
    h2{
      color:black;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
    .all-charts{
        display: flex;
        flex-direction: column;
    }
    .chart-box{
        flex: 100%;
    }
    .chart-holder{
        padding-top: 4em;
        background: #272727;
        color: white;
        width: 100%;
        position: relative;
    }
</style>